import React from "react";

/**
 * Botón base del sistema de UI.
 * Props:
 *  - variant: "primary" | "secondary" | "outline" | "danger" | "ghost"
 *  - size: "sm" | "md" | "lg"
 *  - loading: muestra spinner y deshabilita el botón
 *  - fullWidth: ocupa el 100% del ancho del contenedor
 *  - icon: nodo opcional (icono) a la izquierda del texto
 */
const Button = React.forwardRef(function Button(
  {
    variant = "primary",
    size = "md",
    loading = false,
    fullWidth = false,
    icon = null,
    disabled = false,
    className = "",
    children,
    type = "button",
    ...rest
  },
  ref
) {
  const classes = [
    "sw-ui-btn",
    `sw-ui-btn--${variant}`,
    `sw-ui-btn--${size}`,
    fullWidth ? "sw-ui-btn--block" : "",
    loading ? "sw-ui-btn--loading" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && <span className="sw-ui-btn-spinner" aria-hidden="true" />}
      {!loading && icon && <span className="sw-ui-btn-icon">{icon}</span>}
      <span className="sw-ui-btn-label">{children}</span>
    </button>
  );
});

export default Button;
